import React, { useContext } from "react";

import { DispatchContext, StateContext } from "bodycodi/cmap/app/components/common/context";
import CustomDialog from "bodycodi/cmap/app/components/common/customDialog";
import logo from "bodycodi/cmap/app/img/bodycodi-logo-blue.png";

type FindPasswordCompletePop = {
  name: string;
};

const FindPasswordCompletePopWrap = ({ name }: FindPasswordCompletePop) => {
  const { state: state } = useContext(StateContext);
  const { dispatch } = useContext(DispatchContext);

  const handleClose = () => {
    dispatch({
      type: "POP_UP_OPEN",
      id: "FIND_PASSWORD_COMPLETE_POP",
      open: { findPasswordCompletePop: false },
    });
  };

  return (
    <>
      <CustomDialog open={state.findPasswordCompletePop} onClose={handleClose}>
        {state.findPasswordCompletePop && (
          <>
            <FindPasswordCompletePop name={name} />
          </>
        )}
      </CustomDialog>
    </>
  );
};

const FindPasswordCompletePop = ({ name }: FindPasswordCompletePop) => {
  const { dispatch } = useContext(DispatchContext);

  const handleClickGoLogin = () => {
    dispatch({ type: "CLOSE_ALL_POP" });
  };

  return (
    <div className="find-password-complete-pop">
      <div>
        <img className="icon" src={logo} />
        <div className="regular1 black" style={{ textAlign: "center" }}>
          <span className="bold balck2">{name}</span>님의 <br />
          비밀번호가 변경되었습니다.
        </div>
      </div>
      <div className="btn" onClick={handleClickGoLogin}>
        확인
      </div>
    </div>
  );
};

export default FindPasswordCompletePopWrap;
